// OPS Occult Library comparative visual archive v3 — Abraxas source pack.
(()=>{
  const TITLE='abraxas';
  const SOURCES=[
    {
      date:'c. 100–400 CE',
      period:'Roman-period antiquity',
      creator:'Unknown Roman-period gem engraver; collection photograph by Jakob Faurvig',
      work:'Abraxas amulet with cockerel head, armoured torso, whip, shield and serpent legs',
      page:'Object I1679',
      institution:'Thorvaldsens Museum, Copenhagen',
      collection:'Thorvaldsen’s Collections — Collection of Gems (I); inventory I1679',
      imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/Abraxas_I1679.jpg?width=1200',
      sourceUrl:'https://commons.wikimedia.org/wiki/File:Abraxas_I1679.jpg',
      rights:'Creative Commons CC0 1.0 Universal Public Domain Dedication for the museum photograph',
      rightsUrl:'https://creativecommons.org/publicdomain/zero/1.0/',
      attribution:'Abraxas amulet, c. 100–400 CE, Thorvaldsens Museum I1679. Photograph by Jakob Faurvig, Thorvaldsens Museum; CC0 1.0.',
      medium:'Engraved gemstone amulet',
      technique:'Glyptic engraving; exact cutting method is not specified in the cited image record',
      material:'Jasper',
      colour:'Natural dark stone; colour museum photograph',
      visualCharacter:'A compact oval gem carries a dense composite figure cut in shallow lines: cockerel head, armoured torso, whip, shield and tightly curling serpent legs. The worn stone surface and engraved contours keep the image visibly tied to a small portable object rather than a later drawn emblem.',
      note:'The strongest starting point is an actual Roman-period object rather than a later occult redrawing. The compact jasper amulet preserves the familiar composite anatomy as engraved glyptic design.'
    },
    {
      date:'1657',
      period:'Mid-17th-century antiquarian scholarship',
      creator:'Joannes Macarius; illustrated/commented by Johannes Chifletius',
      work:'Abraxas, seu Apistopistus — table of Basilidean talismans',
      page:'p. 37 / table reproduced in the 1657 volume',
      institution:'Historical book scan via Internet Archive; reproduction hosted by Wikimedia Commons',
      collection:'Abraxas, seu Apistopistus: Antiquaria de gemmis Basilidianis disquisitio (1657)',
      imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/Abraxas_seu_Apistopistus_-_Talisman_pg.037.png?width=1200',
      sourceUrl:'https://commons.wikimedia.org/wiki/File:Abraxas_seu_Apistopistus_-_Talisman_pg.037.png',
      rights:'Public domain historical work; Wikimedia Commons records Public Domain Mark 1.0',
      rightsUrl:'https://creativecommons.org/publicdomain/mark/1.0/',
      attribution:'Joannes Macarius with Johannes Chifletius, table of Basilidean talismans from Abraxas, seu Apistopistus, 1657. Public-domain reproduction via Wikimedia Commons / Internet Archive.',
      medium:'Antiquarian book plate / comparative talisman table',
      technique:'Printed line illustration; the exact historical print process is not stated on the cited image record',
      material:'Printing ink on paper',
      colour:'Monochrome',
      visualCharacter:'Multiple talismanic figures are isolated and arranged for comparison on a printed page. Fine black outlines, inscriptions and specimen-like spacing turn individual gems into a classified visual table rather than a narrative scene.',
      note:'By 1657 the gems have become antiquarian evidence arranged for comparison. This plate is useful precisely because it shows the shift from portable magical object to classified printed specimen.'
    },
    {
      date:'1863',
      period:'Mid-19th-century demonological reinterpretation',
      creator:'Louis Le Breton; engraving associated with M. Jarrault for Jacques Collin de Plancy',
      work:'Abracax / Abraxas illustration from Dictionnaire Infernal, 6th edition',
      page:'Entry “Abracax”, 6th edition',
      institution:'Bibliothèque nationale de France / Gallica; reproduction hosted by Wikimedia Commons',
      collection:'Jacques Collin de Plancy, Dictionnaire Infernal, 6th ed. (1863)',
      imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/Abraxas.png?width=1200',
      sourceUrl:'https://commons.wikimedia.org/wiki/File:Abraxas.png',
      rights:'Public domain historical illustration; Wikimedia Commons records Public Domain Mark 1.0',
      rightsUrl:'https://creativecommons.org/publicdomain/mark/1.0/',
      attribution:'Louis Le Breton and M. Jarrault, Abracax / Abraxas, Dictionnaire Infernal, 6th ed., 1863. Public-domain reproduction via BnF Gallica / Wikimedia Commons.',
      medium:'Demonological book engraving',
      technique:'Engraving after a drawing; the cited record associates the illustration with M. Jarrault',
      material:'Printing ink on paper',
      colour:'Monochrome',
      visualCharacter:'The composite body is redrawn as a freestanding creature with crisp contour, patterned armour and darker hatch work. Compared with the ancient gem, the anatomy is enlarged, clarified and naturalised for a nineteenth-century illustrated reference book.',
      note:'This is not evidence for the appearance of an ancient gem. It is valuable as evidence of reception: the composite figure has been redrawn and absorbed into a nineteenth-century demonological visual vocabulary.'
    },
    {
      date:'1887',
      period:'Late-19th-century antiquarian and Gnostic scholarship',
      creator:'Charles William King',
      work:'Abraxas gem illustration from The Gnostics and Their Remains, Ancient and Mediaeval',
      page:'1887 edition; exact plate/page is not stated on the Commons file record',
      institution:'Historical book reproduction; source scan linked through Open Library / Wikimedia Commons',
      collection:'Charles W. King, The Gnostics and Their Remains, Ancient and Mediaeval (1887)',
      imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/Gema_o_Piedra_Abraxas_de_la_obra_%22The_Gnostics_and_their_remains%22_de_Charles_W._King%2C_1887.jpg?width=1000',
      sourceUrl:'https://commons.wikimedia.org/wiki/File:Gema_o_Piedra_Abraxas_de_la_obra_%22The_Gnostics_and_their_remains%22_de_Charles_W._King,_1887.jpg',
      rights:'Public domain historical work and faithful reproduction; Wikimedia Commons records Public Domain Mark 1.0',
      rightsUrl:'https://creativecommons.org/publicdomain/mark/1.0/',
      attribution:'Charles W. King, Abraxas gem illustration, The Gnostics and Their Remains, Ancient and Mediaeval, 1887. Public-domain reproduction via Wikimedia Commons.',
      medium:'Antiquarian book illustration of an engraved gem',
      technique:'Printed line illustration; exact print process is not stated on the cited image record',
      material:'Printing ink on paper',
      colour:'Monochrome',
      visualCharacter:'The gem is presented as a compact inscribed specimen, with the figure held inside the stone’s boundary and lettering retained as part of the object. Strong black line and simplified tonal marks favour legibility over the surface texture of the original stone.',
      note:'King brings the gem back into antiquarian discussion after the demonological redrawing. The inscriptions and engraved-stone format make a useful comparison with both the ancient museum object and the 1657 specimen tables.'
    }
  ];

  const key=(value)=>String(value||'').trim().toLowerCase();
  const nudgeRenderer=()=>{
    const target=document.querySelector('[data-library-reader]');
    if(!target) return;
    const marker=document.createComment('ops-visual-archive-v3-ready');
    target.appendChild(marker);
    marker.remove();
  };
  const install=()=>{
    const pack=window.OPS_OCCULT_EDITORIAL;
    if(!pack||!Array.isArray(pack.entries)) return false;
    const entry=pack.entries.find((item)=>key(item&&item.title)===TITLE);
    if(!entry) return false;
    entry.visualSources=SOURCES.map((source)=>({...source}));
    nudgeRenderer();
    return true;
  };
  if(!install()) document.addEventListener('DOMContentLoaded',install,{once:true});
})();
